import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { first, mergeMap } from 'rxjs/operators';
import { LocalStorageService } from '@us/web/shared/data-access';
import { selectToken } from '../+state/auth.reducer';
import { AccessToken } from '../models';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    private readonly AUTH_HEADER = 'X-Authorization';

    constructor(private store: Store, private localStorage: LocalStorageService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        let req = request;
        if (!req.headers.has('Content-Type')) {
            req = req.clone({
                headers: req.headers.set('Content-Type', 'application/json')
            });
        }

        if (req.url.includes('/partner/oauth2/token') || req.url.includes('/partner/oauth2/refresh')) {
            return next.handle(req);
        }

        if (!req.headers?.has('shop_id') && (!req.body || !('shop_id' in req.body)) && !req.params?.has('shop_id')) {
            const shopId = this.localStorage.getItem('shop_id');
            if (shopId) {
                req = req.clone({
                    headers: req.headers.set('shop_id', shopId),
                    ...(req.method === 'GET'
                        ? {
                              setParams: {
                                  shop_id: shopId
                              }
                          }
                        : {
                              body: {
                                  ...req.body,
                                  shop_id: shopId
                              }
                          })
                });
            }
        }

        return this.addAuthenticationToken(req).pipe(
            first(),
            mergeMap((requestWithToken: HttpRequest<any>) => next.handle(requestWithToken))
        );
    }

    private addAuthenticationToken(request: HttpRequest<any>): Observable<HttpRequest<any>> {
        return this.store.select(selectToken).pipe(
            first(),
            mergeMap((token: AccessToken | null) => {
                let req = request;
                if (token) {
                    req = req.clone({
                        headers: req.headers.set(this.AUTH_HEADER, `Bearer ${token.accessToken}`)
                    });
                } else {
                    console.warn('Token not found!');
                }
                return of(req);
            })
        );
    }
}
